import React, { useState, useEffect } from 'react'
import CountUp from 'react-countup'
import { API_BASE_URL } from '../config';


interface StatsData {
    totalDownloads: number;
    totalUsers: number;
    activeUsers: number;
    totalGroups: number;
    completedHatim: number;
    satisfactionRate: number;
}

// Sayıyı K formatına çevir (örn: 1500 -> {value: 1.5, suffix: 'K+'})
const formatNumber = (num: number): { value: number; decimals: number; suffix: string } => {
    if (num >= 1000) {
        const value = num / 1000;
        // Eğer tam sayıya yakınsa decimal gösterme
        const decimals = value % 1 < 0.05 || value % 1 > 0.95 ? 0 : 1;
        return { value: Math.round(value * 10) / 10, decimals, suffix: 'K+' };
    }
    return { value: num, decimals: 0, suffix: '+' };
};

export default function CounterSection() {
    const [isVisible, setIsVisible] = useState(false);
    const [stats, setStats] = useState<StatsData | null>(null);
    const [loading, setLoading] = useState(true);

    // İstatistikleri çek
    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/stats/public`);
                const data = await response.json();
                if (data.success) {
                    setStats(data.data);
                }
            } catch (error) {
                console.error('İstatistikler yüklenirken hata:', error);
                // Hata durumunda varsayılan değerleri kullan
                setStats({
                    totalDownloads: 45000,
                    totalUsers: 38000,
                    activeUsers: 12000,
                    totalGroups: 2800,
                    completedHatim: 1500,
                    satisfactionRate: 98
                });
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    // Bölüm ekrana girince sayaç başlar (telefonda sayfayı body kaydırdığı için scroll olayı yerine IntersectionObserver)
    useEffect(() => {
        const element = document.getElementById('stats');
        if (!element) return;
        const observer = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) {
                setIsVisible(true);
                observer.disconnect();
            }
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    // İstatistikleri formatla
    const downloads = stats ? formatNumber(stats.totalDownloads) : { value: 45, decimals: 0, suffix: 'K+' };
    const users = stats ? formatNumber(stats.totalUsers) : { value: 38, decimals: 0, suffix: 'K+' };
    const groups = stats ? formatNumber(stats.totalGroups) : { value: 2.8, decimals: 1, suffix: 'K+' };
    const hatim = stats ? formatNumber(stats.completedHatim) : { value: 1.5, decimals: 1, suffix: 'K+' };

    const kutular = [
        { veri: downloads, metin: <>Toplam uygulama <br /> indirme sayısı</> },
        { veri: users, metin: <>Aktif kullanıcı <br /> sayısı</> },
        { veri: groups, metin: <>Toplam oluşturulan <br /> grup sayısı</> },
        { veri: hatim, metin: <>Tamamlanan <br /> hatim sayısı</> }
    ];

    return (
        <section className="ht-sec ht-stats" id="stats">
            <div className="ht-wrap">
                <div className="ht-card">
                    {kutular.map((k, i) => (
                        <div key={i} className="ht-stat">
                            <div className="ht-stat-num">
                                {isVisible && !loading && (
                                    <CountUp end={k.veri.value} decimals={k.veri.decimals} duration={2.5} />
                                )}
                                {k.veri.suffix}
                            </div>
                            <p>{k.metin}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
